import {convertToAudioFormat} from 'lib/helpers/mp3';
import {sendFrames, blobToDataURL, addCanvasWebWorker, sendProgress} from 'lib/helpers/common';
import {generateQrCode} from 'lib/service/qrcode.service';
import HelpService from 'lib/service/help.service';

const throttle = require('lodash/throttle');

var mp3Parser = require("mp3-parser");
var Promise = require('promise');

export default (function () {

    function toFlatArray(arr, outBuffer) {
        if (outBuffer == null) {
            outBuffer = [];
        }
        for (var i = 0; i < arr.length; i++) {
            if (typeof arr[i] == 'object') {
                //an array
                toFlatArray(arr[i], outBuffer)
            } else {
                //a simple element
                outBuffer.push(arr[i]);
            }
        }
        return outBuffer;
    }

    function strToBuffer(str) {
        // return new Blob([str]);

        var arr = new Uint8Array(str.length);
        for (var i = 0; i < str.length; i++) {
            arr[i] = str.charCodeAt(i)
        }
        return arr;
    }

    function numToBuffer(num) {
        var parts = [];
        while (num > 0) {
            parts.push(num & 0xff)
            num = num >> 8
        }
        return new Uint8Array(parts.reverse());
    }

    function doubleToString(num) {
        return [].slice.call(
            new Uint8Array(
                (
                    new Float64Array([num]) //create a float64 array
                ).buffer) //extract the array buffer
            , 0) // convert the Uint8Array into a regular array
            .map(function (e) { //since it's a regular array, we can now use map
                return String.fromCharCode(e) // encode all the bytes individually
            })
            .reverse() //correct the byte endianness (assume it's little endian for now)
            .join('') // join the bytes in holy matrimony as a string
    }

    function bitsToBuffer(bits) {
        var data = [];
        var pad = (bits.length % 8) ? (new Array(1 + 8 - (bits.length % 8))).join('0') : '';
        bits = pad + bits;
        for (var i = 0; i < bits.length; i += 8) {
            data.push(parseInt(bits.substr(i, 8), 2))
        }
        return new Uint8Array(data);
    }

    function generateEBML(json, outputAsArray) {
        var ebml = [];
        for (var i = 0; i < json.length; i++) {
            if (!('id' in json[i])) {
                //already encoded blob or byteArray
                ebml.push(json[i]);
                continue;
            }

            var data = json[i].data;
            if (typeof data == 'object') data = generateEBML(data, outputAsArray);
            if (typeof data == 'number') data = ('size' in json[i]) ? numToFixedBuffer(data, json[i].size) : bitsToBuffer(data.toString(2));
            if (typeof data == 'string') data = strToBuffer(data);

            if (data.length) {
                var z = z;
            }

            var len = data.size || data.byteLength || data.length;
            var zeroes = Math.ceil(Math.ceil(Math.log(len) / Math.log(2)) / 8);
            var size_str = len.toString(2);
            var padded = (new Array((zeroes * 7 + 7 + 1) - size_str.length)).join('0') + size_str;
            var size = (new Array(zeroes)).join('0') + '1' + padded;

            //i actually dont quite understand what went on up there, so I'm not really
            //going to fix this, i'm probably just going to write some hacky thing which
            //converts that string into a buffer-esque thing

            ebml.push(numToBuffer(json[i].id));
            ebml.push(json[i].id == 0x18538067 ? new Uint8Array([0x01, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff]) : bitsToBuffer(size)); // Use unknown size for segment to allow for streaming Matroska
            ebml.push(data)


        }

        //output as blob or byteArray
        if (outputAsArray) {
            //convert ebml to an array
            var buffer = toFlatArray(ebml)
            return new Uint8Array(buffer);
        } else {
            return new Blob(ebml, {type: "video/x-matroska"});
        }
    }

    function makeSimpleBlock(data) {
        var flags = 0;
        if (data.keyframe) flags |= 128;
        if (data.invisible) flags |= 8;
        if (data.lacing) flags |= (data.lacing << 1);
        if (data.discardable) flags |= 1;
        if (data.trackNum > 127) {
            throw "TrackNumber > 127 not supported";
        }
        var out = [data.trackNum | 0x80, data.timecode >> 8, data.timecode & 0xff, flags].map(function (e) {
            return String.fromCharCode(e)
        }).join('') + data.frame;

        return out;
    }

// the actual demo code, yaaay
    function VideoRecorder(canvas, {duration, frequency, details}, resolve) {
        this.counter = 0;
        this.audio_ts = 0;
        this.details = details;
        this.frequency = frequency;
        this.resolve = resolve;
        this.duration = duration;
        this.SamplingFrequency;
        this.Channels;
        this.mp3;
        this.mp3_offset = 0;
        this.width = canvas.width;
        this.height = canvas.height;
        this._protobufParts = [];
        this.order = [];
        this.frames = [];
        this.sendFrameTimeout = [];
        this.mp3_eof = false;
        this.oldFrame = null;
        this.lastFrame = null;

        this.addListenerWebWorker();

        this._throttleSendFrameByOrder = throttle(() => {
            this.sendFrameByOrder();
        }, 2000)
    }

    VideoRecorder.prototype.addAudio = function (mp3_buffer, type) {
        return new Promise(async (res, rej) => {
            mp3_buffer = await convertToAudioFormat(mp3_buffer);

            this.mp3_buffer = mp3_buffer;
            this.mp3 = new DataView(mp3_buffer);
            var header = mp3Parser.readFrameHeader(this.mp3);
            this.SamplingFrequency = header.samplingRate;
            this.Channels = header.channelMode == "Single channel (Mono)" ? 1 : 2;

            res(generateEBML(this.EBMLHeader(), true));
        })
    }

    VideoRecorder.prototype.addQRCode = function () {
        const addQrCodeOnFrame = async () => {
            const helperService = new HelpService();
            const url = helperService.location.href.split('?')[0];

            return generateQrCode(url, this.lastFrame);
        }

        return addQrCodeOnFrame();
    }

    VideoRecorder.prototype.addListenerWebWorker = function () {
        const worker = addCanvasWebWorker();

        worker.onmessage = async (e) => {
            if (e.data) {

                try {
                    const {video_ts, blob} = e.data;
                    const dataUrl = await blobToDataURL(blob);
                    this.lastFrame = dataUrl;

                    const frame = atob(dataUrl.slice(23));
                    this.generateEBLMFrame(video_ts, frame);
                } catch (e) {
                    console.error(e, dataUrl)
                }

            }
        }

        worker.onerror = function (e) {
            return false;
        }

        this.worker = worker;

        this.worker.postMessage({action: "setFrameDetails", data: {width: this.width, height: this.height}});
    }

    VideoRecorder.prototype.addQrCodeFrames = function (video_ts) {
        return new Promise(async (req, rej) => {
            const qrcode = await this.addQRCode()
            const frame = atob(qrcode.slice(23));
            let duration = 0;

            while (duration < 5) {
                const video_ts_qr = video_ts + (duration * 1000);

                this.generateEBLMFrame(video_ts_qr, frame);
                sendFrames(this.frames[video_ts_qr]);
                delete this.frames[video_ts_qr];

                duration++;
            }
            req();
        })
    }

    VideoRecorder.prototype.sendFrameByOrder = function () {
        const video_ts = this.order[0];

        if (typeof video_ts !== "undefined") {
            const frame = this.frames[video_ts];

            if (frame) {
                sendProgress(Math.ceil(video_ts / this.duration * 100));
                sendFrames(frame);
                this.order.shift();
                delete this.frames[video_ts];
                console.log('sendFrameByOrder', video_ts)

                if (video_ts + this.frequency * 1.5 >= this.duration) {
                    const export_finish = async (video_ts) => {
                        if (this.details.qr_code) await this.addQrCodeFrames(video_ts);

                        sendProgress(100);
                        this.resolve({duration: this.duration});
                    }

                    export_finish(video_ts);

                    return;
                }

                this.sendFrameByOrder();
            }
        } else {
            console.log('no data for send')
        }
    }

    VideoRecorder.prototype.generateEBLMFrame = function (video_ts, frame) {
        var cluster = [{
            "id": 0x1f43b675, // Cluster
            "data": [
                {
                    "data": Math.round(video_ts),
                    "id": 0xe7 // Timecode
                }
            ].concat({
                data: makeSimpleBlock({
                    discardable: 0,
                    frame: frame,
                    invisible: 0,
                    keyframe: 1,
                    lacing: 0,
                    trackNum: 1,
                    timecode: 0
                }),
                id: 0xa3
            })
        }];

        while (this.audio_ts < video_ts && this.mp3_eof == false) {
            var audioFrame = mp3Parser.readFrame(this.mp3, this.mp3_offset, true);
            if (audioFrame == null) {
                // this.mp3_eof = true;
                console.log("this.mp3_eof");
                break;
            }
            var duration = audioFrame._section.sampleLength / audioFrame.header.samplingRate * 1000;

            cluster[0].data.push({
                data: makeSimpleBlock({
                    discardable: 0,
                    frame: String.fromCharCode.apply(null, new Uint8Array(this.mp3_buffer.slice(audioFrame._section.offset, audioFrame._section.offset + audioFrame._section.byteLength))),
                    invisible: 0,
                    keyframe: 1,
                    lacing: 0,
                    trackNum: 2,
                    timecode: Math.round(this.audio_ts - video_ts)
                }),
                id: 0xa3
            });
            this.mp3_offset = audioFrame._section.nextFrameIndex;
            this.audio_ts += duration;
        }

        this.frames[video_ts] = generateEBML(cluster, true);

        this._throttleSendFrameByOrder();
    }

    VideoRecorder.prototype.add = function (canvas, video_ts, flag) {
        return new Promise(async (res, rej) => {
            const prevFrame = this.frames[video_ts - this.frequency];

            if (flag && prevFrame) {
                this.frames[video_ts] = prevFrame;

                this._throttleSendFrameByOrder();
                console.log('copy old frame', video_ts)
            } else {
                // frame = atob(canvas.toDataURL('image/jpeg', 0.75).slice(23));
                const bitmap = await createImageBitmap(canvas);
                this.worker.postMessage({action: "addFrame", data: {bitmap, video_ts}}, [bitmap]);
                console.log('duration of export', video_ts)
            }

            this.order.push(video_ts);

            res();
        })
    }

    VideoRecorder.prototype.EBMLHeader = function () {
        return [
            {
                "id": 0x1a45dfa3, // EBML
                "data": [
                    {
                        "data": 1,
                        "id": 0x4286 // EBMLVersion
                    }, {
                        "data": 1,
                        "id": 0x42f7 // EBMLReadVersion
                    }, {
                        "data": 4,
                        "id": 0x42f2 // EBMLMaxIDLength
                    }, {
                        "data": 8,
                        "id": 0x42f3 // EBMLMaxSizeLength
                    }, {
                        "data": "matroska",
                        "id": 0x4282 // DocType
                    }, {
                        "data": 2,
                        "id": 0x4287 // DocTypeVersion
                    }, {
                        "data": 2,
                        "id": 0x4285 // DocTypeReadVersion
                    }
                ]
            },
            {
                "id": 0x18538067, // Segment
                "data": [
                    {
                        "id": 0x1549a966, // Info
                        "data": [
                            {
                                "data": 1e6, //do things in millisecs (num of nanosecs for duration scale)
                                "id": 0x2ad7b1 // TimecodeScale
                            }, {
                                "data": "EyeSpy360",
                                "id": 0x4d80 // MuxingApp
                            }, {
                                "data": "EyeSpy360",
                                "id": 0x5741 // WritingApp
                            }
                        ]
                    },
                    {
                        "id": 0x1654ae6b, // Tracks
                        "data": [
                            {
                                "id": 0xae, // TrackEntry
                                "data": [
                                    {
                                        "data": 1,
                                        "id": 0xd7 // TrackNumber
                                    }, {
                                        "data": 1,
                                        "id": 0x73c5 // TrackUID
                                    }, {
                                        "data": 0,
                                        "id": 0x9c // FlagLacing
                                    }, {
                                        "data": "und",
                                        "id": 0x22b59c // Language
                                    }, {
                                        "data": "V_MJPEG",
                                        "id": 0x86 // CodecID
                                    }, {
                                        "data": 1,
                                        "id": 0x83 // TrackType
                                    }, {
                                        "id": 0xe0,  // Video
                                        "data": [
                                            {
                                                "data": this.width,
                                                "id": 0xb0 // PixelWidth
                                            }, {
                                                "data": this.height,
                                                "id": 0xba // PixelHeight
                                            }
                                        ]
                                    }
                                ]
                            }, {
                                "id": 0xae, // TrackEntry
                                "data": [
                                    {
                                        "data": 2,
                                        "id": 0xd7 // TrackNumber
                                    }, {
                                        "data": 2,
                                        "id": 0x73c5 // TrackUID
                                    }, {
                                        "data": 0,
                                        "id": 0x9c // FlagLacing
                                    }, {
                                        "data": "und",
                                        "id": 0x22b59c // Language
                                    }, {
                                        "data": "A_MPEG/L3",
                                        "id": 0x86 // CodecID
                                    }, {
                                        "data": 2,
                                        "id": 0x83 // TrackType
                                    }, {
                                        "id": 0xe1,  // Audio
                                        "data": [
                                            {
                                                "data": doubleToString(this.SamplingFrequency),
                                                "id": 0xb5 // SamplingFrequency
                                            }, {
                                                "data": this.Channels,
                                                "id": 0x9f // Channels
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];
    }


    return VideoRecorder;
})()
